import { Theme } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const StylingContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  @media (max-width: ${Theme.break.small}) {
    flex-direction: column;
  }
`;

export const ThemeConfigContainer = styled.div`
  width: 50%;
  background-color: #fff;
  padding: var(--spacing-xxl);
  justify-content: center;
  display: flex;
  flex-direction: column;
  @media (max-width: ${Theme.break.small}) {
    width: 100%;
    order: 1;
    overflow-y: auto;
    height: calc(100% - 300px);
  }
`;

export const ThemePreviewContainer = styled.div`
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: ${Theme.break.small}) {
    width: 100%;
    order: 0;
  }
`;

export const Title = styled.div`
  font-size: var(--font-size-lg, 20px);
  font-weight: 900;
`;

export const Subtitle = styled.div`
  font-size: var(--font-size-sm, 14px);
  font-weight: 400;
`;

export const LogoUploader = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
`;

export const ThemeColorPicker = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
`;

export const LogoUploadButtonContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
`;

export const SmallText = styled.div`
  color: var(--Shade-Grey-80, #474749);
  font-size: 13px;
  font-weight: 400;
  line-height: var(--font-line-height-sm, 20px);
`;

export const ColorPickerContainer = styled.div`
  display: flex;
  gap: 20px;
  justify-content: space-between;
`;

export const ColorPickerPiece = styled.div`
  display: flex;
  width: calc(50% - 10px);
  flex-direction: column;
  .custom-picker {
    width: 100%;
    @media (max-height: 1080px) {
      .popover {
        bottom: 50px;
      }
    }
  }
`;

export const Preview = styled.div<{ color: string }>`
  width: 550px;
  height: 320px;
  background-color: ${({ color }) => color};
  border: 2px solid var(--color-gray-950, #19191b);
  display: flex;
  padding: var(--spacing-xxl);
  align-items: center;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const Header = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  font-size: var(--font-size-xl, 24px);
  font-weight: 900;
  line-height: var(--font-line-height-xl, 36px);
`;

export const Body = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  font-size: var(--font-size-sm, 14px);
  font-weight: 400;
  line-height: var(--font-line-height-sm, 20px);
`;
export const LineSeparator = styled.div<{ color: string }>`
  width: 100%;
  height: 5px;
  border-radius: 10px;
  background-color: ${({ color }) => color};
  margin: var(--spacing-md) 0;
`;
